module.exports = __webpack_public_path__ + "static/media/error.e887ac2d.svg";